import Loadable, { NullLoader } from '@comeon/loadable';

// Make all the containers loadable under single chunk.

const SportsbookEventPageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-event-page" */
			'./sportsbook-event-page-container'
		),
	loading: NullLoader
});

const SportsbookEventBetBuilderContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-event-page" */
			'./components/sportsbook-event-bet-builder-prompt'
		),
	loading: NullLoader
});

const SportsbookEventOpenBetsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-event-page" */
			'./components/sportsbook-event-open-bets-layout'
		),
	loading: NullLoader
});

const SportsbookEventMarketsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-event-page" */
			'./components/markets/sportsbook-event-markets-container'
		),
	loading: NullLoader
});

export {
	SportsbookEventPageContainer,
	SportsbookEventBetBuilderContainer,
	SportsbookEventOpenBetsContainer,
	SportsbookEventMarketsContainer
};
